
import TableItem from './TableItem';

function Table({ topics, page, showDelete }) {


    return (
        <div className="  font-primary  relative">
            <div className=' bg-white dark:bg-dark_50  rounded-t-xl'>
                <div className="overflow-x-auto overflow-hidden">
                    <table className="table-auto w-full  divide-y  divide-gray-200">
                        <thead className="text-xs uppercase w-full  text-[#8C8C8C] ">
                            <tr>
                                <th className="px-2 border-2 border-lead100 dark:border-lead500  first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div className="font-semibold text-center">No.</div>
                                </th>
                                <th className="px-2 border-2 border-lead100 dark:border-lead500 w-1/3 first:pl-10 last:pr-10 py-3 whitespace-nowrap">
                                    <div className="font-semibold flex items-start">Title</div>
                                </th>
                                <th className="px-2 border-2 border-lead100 dark:border-lead500 first:pl-10 last:pr-10 py-3 whitespace-nowrap">
                                    <div className="font-semibold flex items-start">Author</div>
                                </th>
                                <th className="px-2 border-2 border-lead100 dark:border-lead500 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div className="font-semibold text-center">Category</div>
                                </th>
                                <th className="px-2 border-2 border-lead100 dark:border-lead500 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div className="font-semibold text-center">Date</div>
                                </th>
                                {page === 'Draft' && (
                                    <th className="px-2 border-2 border-lead100 dark:border-lead500 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                        <div className="font-semibold text-center">State</div>
                                    </th>
                                )}
                                {page === 'Published' && (
                                    <th className="px-2 border-2 border-lead100 dark:border-lead500 first:pl-5 last:pr-5 py-3 ">
                                        <div className="font-semibold text-center">Slug</div>
                                    </th>
                                )}
                                <th className="px-2 border-2 border-lead100 dark:border-lead500 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div className="font-semibold text-center">Action</div>
                                </th>
                                <th className="px-2 border-2 border-lead100 dark:border-lead500 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div className="font-semibold text-center">Article Link</div>
                                </th>
                            </tr>
                        </thead>
                        {
                            topics?.map((data, index) => {
                                return (
                                    <TableItem
                                        showDelete={showDelete}
                                        id={index + 1}
                                        href={data?.aid}
                                        page={page}
                                        title={data?.title}
                                        author={data?.author}
                                        category={data?.category_tag}
                                        state={data?.complete}
                                        date={data?.lastEditOn || data?.publishedOn}
                                        slug={data?.slug}
                                    />
                                )
                            })
                        }
                    </table>
                </div>
            </div>
            {/* <div className="dark:bg-dark_50  border-2 border-t-0 border-lead100 dark:border-lead500">
                <TablePagination
                    itemsPerPage={itemsPerPage}
                    totalItems={topics?.length}
                    currentPage={currentPage}
                    paginate={paginate}
                    indexOfFirstItem={indexOfFirstItem}
                    indexOfLastItem={indexOfLastItem}
                />
            </div> */}
        </div>
    );
}

export default Table;
